import { rem } from 'polished';
import styled from 'styled-components';

const sizes = {
  tooltip: {
    marginBottom: 14,
  },
  cancel: {
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
};

export const TooltipWrapper = styled.div`
  margin-left: auto;
  margin-bottom: ${rem(sizes.tooltip.marginBottom)};
  align-self: end;

  &,
  div,
  button {
    cursor: not-allowed;
  }

  button {
    float: none;
  }
`;

export const CancelButton = styled.button`
  background: none;
  border: none;
  float: right;
  margin: -${rem(sizes.cancel.paddingVertical)} -${rem(
      sizes.cancel.paddingHorizontal,
    )}
    ${rem(20 - sizes.cancel.paddingVertical)} 0;
  padding: ${rem(sizes.cancel.paddingVertical)}
    ${rem(sizes.cancel.paddingHorizontal)};
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.book.appointmentCards.cancel.text};
  font-weight: 400;
  opacity: 0.7;
  border-radius: ${rem(30)};
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover,
  &:focus {
    opacity: 1;
  }

  &:focus {
    outline: ${rem(1)} solid
      ${({ theme }) => theme.colors.book.appointmentCards.cancel.outline};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
